import createStyles from "@mui/styles/createStyles";
export const useStyles = (theme) =>
  createStyles({
    activeChip: {
      backgroundColor: "#ffd900 !important",
      border: "1px solid #ffd900",
      borderRadius: theme.spacing(0.5) + " !important",
      color: "#000000",
      fontWeight: 400,
      "&:hover, &:focus": {
        backgroundColor: "#ffd900 !important",
      },
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(3, 0.5, 3, 0.5) + " !important",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(3, 2, 3, 2),
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3, 2, 3, 2),
      },
    },
    chip: {
      backgroundColor: "#ECF0F4",
      border: "1px solid #ECF0F4",
      borderRadius: theme.spacing(0.5) + " !important",
      color: "#22334f",
      fontWeight: 400,
      "&:hover, &:focus": {
        backgroundColor: "#ffd900 !important",
      },
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(3, 0.5, 3, 0.5) + " !important",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(3, 2, 3, 2),
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3, 2, 3, 2),
      },
    },
    activeChipLarge: {
      backgroundColor: "#ffd900 !important",
      border: "1px solid #eb5757",
      borderRadius: theme.spacing(0.5) + " !important",
      color: "#22334f",
      "&:hover, &:focus": {
        backgroundColor: "#ffd900 !important",
      },
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(3, 3) + " !important",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(3, 3) + " !important",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3, 3) + " !important",
      },
    },
    chipLarge: {
      backgroundColor: "#ffffff",
      border: "1px solid #eb5757",
      borderRadius: theme.spacing(0.5) + " !important",
      color: "#22334f",
      "&:hover, &:focus": {
        backgroundColor: "#ffd900 !important",
      },
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(3, 3) + " !important",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(3, 3) + " !important",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3, 3) + " !important",
      },
    },
    bold: {
      fontWeight: 500,
    },
    chipsBox: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      flexWrap: "wrap",
    },
    label: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column",
    },
    fullWidth: {
      width: "90%",
      display: "flex",
      justifyContent: "flex-start",
    },
    minWidth: {
      minWidth: "16vh",
    },
    regular: {
      fontWeight: 400,
    },
    thin: {
      fontWeight: 300,
    },
    wrap: {
      whiteSpace: "pre-wrap",
    },
  });
